import React from "react";
import locale from "@bonliva-crm/locale";
import { Grid } from "@material-ui/core";
import Select, { Option } from "@components/Select";
import { SecondaryButton, Body } from "@components";

type ExpMultiSelectProps = {
  btnClick: (e) => void;
  btnDisabled: boolean;
  name: string;
  onChange: (value: string[]) => void;
  SelectProps?: Partial<React.ComponentProps<typeof Select>>;
  selectedVal: string[];
  selectOptions: string[] | Option[];
  error?: string;
};

export function ExpMultiSelect(props: ExpMultiSelectProps) {
  const { name, selectOptions, onChange, selectedVal, btnClick, btnDisabled } = props;

  const options =
    typeof selectOptions[0] === "string"
      ? (selectOptions as string[]).toLabelValue()
      : (selectOptions as Option[]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={6} md={4} lg={2}>
        <Body>{name}</Body>
      </Grid>

      <Grid container item xs={6} md={8} lg={4} spacing={1}>
        <Grid item xs={8} container alignItems="center">
          <Select
            creatable
            fullWidth
            multi
            options={options}
            sortOptions={true}
            optionType={"checkbox"}
            onChange={onChange}
            value={selectedVal}
            error={!!props.error}
            {...(props.SelectProps as any)}
          />
        </Grid>

        <Grid item xs={4}>
          <SecondaryButton
            onClick={btnClick}
            disabled={btnDisabled}
            variant="text"
            fullWidth
          >
            {locale.Add}
          </SecondaryButton>
        </Grid>
      </Grid>
    </Grid>
  );
}
